// extracted by mini-css-extract-plugin
export default {"root":"w8mnNUsnPSgSOY_SWxkH","loading":"fn4XshDkGvhI_K45P36P"};